module.exports = __webpack_public_path__ + "public/images/slider/peremutov-circle.66547ae0be17bbcdd063feebf38cd143.webp";